// The API is requested only by an explicitly activated film player.
let pendingAPI;
export const loadYouTubeAPI = () => {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (pendingAPI) return pendingAPI;
  pendingAPI = new Promise((resolve, reject) => {
    const previous = window.onYouTubeIframeAPIReady;
    const script = document.createElement('script');
    let timeout;
    const failure = () => {
      clearTimeout(timeout); script.remove(); pendingAPI = null;
      window.onYouTubeIframeAPIReady = previous;
      reject(new Error('YouTube could not be reached. Open the film directly using the link below.'));
    };
    window.onYouTubeIframeAPIReady = () => {
      clearTimeout(timeout); window.onYouTubeIframeAPIReady = previous;
      previous?.();
      window.YT?.Player ? resolve(window.YT) : failure();
    };
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true; script.dataset.filmApi = 'youtube';
    script.onerror = failure;
    timeout = setTimeout(failure, 15000);
    document.head.appendChild(script);
  });
  return pendingAPI;
};

export const youtubeError = code => ({
  2: 'YouTube rejected the video request.',
  5: 'YouTube could not play this video in this browser.',
  100: 'This video is unavailable on YouTube.',
  101: 'YouTube has restricted playback of this embedded video.',
  150: 'YouTube has restricted playback of this embedded video.',
  153: 'YouTube could not verify this player’s website identity.',
}[code] || 'YouTube playback is currently unavailable.');